import React, { Fragment } from 'react'

import AboutUs from './AboutUs'
import Banner from './Banner'
import OurValues from './OurValues'
import Process from './Process'

export default function HomePage() {
    return (
        <Fragment>
            <Banner />
            <AboutUs />
            <OurValues />
            <Process />
        </Fragment>
    )
}
